/**
 * Os dois modos do jogo, e onde cada um existe.
 *
 * **1 Jogador** roda inteiro no aparelho, sem servidor: é o modo do arquivo
 * exportado, o único lugar onde o hotseat de até oito treinadores faz sentido,
 * e o único que funciona sem sinal.
 *
 * **Online Multiplayer** é a carreira da conta, que vive no servidor, mais as
 * ligas e o ranqueado.
 *
 * Os dois existem nas três plataformas desde a tela "Carregar jogo" (E1.7,
 * etapa 2). O navegador guarda a carreira local no IndexedDB, que ele pode
 * limpar por conta própria; é por isso que a mesma tela exporta e importa o
 * arquivo `.lmsave`, que é a cópia que não depende do navegador.
 */

import { detectarPlataforma } from "./saves/escolha";

export type Modo = "umJogador" | "online";

/** Estamos dentro do aplicativo instalado (Windows ou Android)? */
export function ehAplicativo(): boolean {
  return detectarPlataforma() !== "web";
}

/**
 * Os modos que esta plataforma oferece, na ordem em que a tela mostra.
 *
 * 1 Jogador vem primeiro: quem quer liga com gente sabe que precisa entrar na
 * conta, e quem só quer jogar não precisa de nada.
 */
export function modosDaPlataforma(): Modo[] {
  return ["umJogador", "online"];
}

/**
 * O modo com que o jogo abre.
 *
 * `null` quer dizer "ainda não escolheu", e a tela inicial pergunta.
 */
export function modoInicial(): Modo | null {
  return null;
}
